import { MATERIAL, MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

const MATERIAL_TO_MATERIAL_MODE = {
  [MATERIAL.PBR]: 'PBR',
  [MATERIAL.BASIC]: 'shaded',
  [MATERIAL.GEOMETRY_ONLY]: 'shaded',
}

/**
 * Inverse of parseHyper3dTextTo3dGen2Data. Builds an openedModel-shaped
 * payload from the current modelSettings so the just-submitted run can be
 * reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseHyper3dTextTo3dGen2Data
 */
export const buildHyper3dTextTo3dGen2FromState = (state, id) => {
  const {
    prompt,
    material,
    targetPolycount,
    polygonType,
    isPrivate,
    selectedUseCase,
  } = state.modelSettings || {}
  const materialMode = material != null ? MATERIAL_TO_MATERIAL_MODE[material] : undefined

  return {
    id,
    providerKey: PROVIDER.HYPER3D,
    providerModelId: MODEL_ID.HYPER3D_TEXT_TO_3D_GEN2,
    prompt,
    private: isPrivate,
    useCase: selectedUseCase,
    providerRunAttributes: {
      ...(targetPolycount != null && { polycount: targetPolycount }),
      ...(polygonType != null && { topology: polygonType }),
      ...(materialMode != null && { materialMode }),
    },
  }
}
